module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "jumbotron bg-transparent text-center margin-none"
  }, [_c('h1', [_vm._v("备份还原")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("导出为 zip 备份文件，导入 zip 后请重新启动通讯管理机。")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 col-xs-12"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "panel-body text-left"
  }, [_c('p', [_vm._v("导出当前管理机配置为 zip 压缩包，便于备份和迁移。")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.exportName),
      expression: "exportName",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "必填，例如：1号站"
    },
    domProps: {
      "value": (_vm.exportName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.exportName = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.exportBackup
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  }), _vm._v(" 下载配置压缩包\n          ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-xs-12"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "panel-body text-left"
  }, [_c('p', [_vm._v("选择之前导出的 zip 备份文件，上传后覆盖当前配置。")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "file",
      "accept": ".zip,application/zip"
    },
    on: {
      "change": _vm.handleFileChange
    }
  })]), _vm._v(" "), (_vm.selectedFileName) ? _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("已选择：" + _vm._s(_vm.selectedFileName))]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "disabled": _vm.importing
    },
    on: {
      "click": _vm.importBackup
    }
  }, [_c('i', {
    staticClass: "fa fa-upload"
  }), _vm._v(" " + _vm._s(_vm.importing ? '导入中...' : '上传并导入配置包') + "\n          ")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('strong', [_vm._v("导出配置")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('strong', [_vm._v("导入配置")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2c1a6ce6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/page/Version.vue
// module id = 82
// module chunks = 0